import { gql } from '@apollo/client';

export const ArtiklerArchiveSEOFragment = gql`
  fragment ArtiklerArchiveSEOFragment on ContentType {
    seo {
      title
      description
      canonicalUrl
      fullHead
      focusKeywords
      robots
      openGraph {
        title
        description
        image {
          secureUrl
          url
        }
      }
    }
  }
`; 